'use strict';

module.exports = {
    submitPersonalData: function () {
        $('form.rmaform').submit(function (e) {
            e.preventDefault();
            $('.invalidCase').addClass('d-none');
            $('.rma-case-used').addClass('d-none');
            $('.invalidProduct').addClass('d-none');
            $('.invalidCaseNumber').addClass('d-none');
            $('.rma-case-redeemed').addClass('d-none');
            var $form = $(this);
            var url = $form.attr('action');
            $form.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                data: $form.serialize(),
                success: function (data) {
                    if (data.success) {
                        location.href = data.redirectUrl;
                    } else {
                        if (data.errorCode === 1) {
                            $('.invalidCase').removeClass('d-none');
                        } else if (data.errorCode === 2) {
                            $('.rma-case-used').removeClass('d-none');
                        } else if (data.errorCode === 3) {
                            $('.invalidProduct').removeClass('d-none');
                        } else if (data.errorCode === 4) {
                            $('.invalidCaseNumber').removeClass('d-none');
                        } else if (data.errorCode === 5) {
                            $('.rma-case-redeemed').removeClass('d-none');
                        }
                        $form.spinner().stop();
                    }
                },
                error: function () {
                    $('.invalidCase').removeClass('d-none');
                    $form.spinner().stop();
                }
            });
            return false;
        });
    }
};
